import { Fragment } from 'react';

import NavLinks from '../NavLinks';

import useMeetSessions from './UseMeetSessions';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Sessions from '@usas/ui-web/components/meetSessions/Sessions';

const MeetSessionsWrite = () => {
  const {
    meetState,
    otsMeetSessionsState,
    isLoading,
    isSaving,
    Constants,
    onAddSession,
    onEditSession,
    onDeleteSession
  } = useMeetSessions();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Meet Sessions</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className='col-xs-12'>
          <Sessions
            showOptionalFields={true}
            requiredFieldsReadOnly={false}
            meetSessionArray={otsMeetSessionsState?.arrayData}
            meetId={meetState?.objData?.meetId}
            meetStartDate={meetState?.objData?.startDate}
            meetEndDate={meetState?.objData?.endDate}
            onAdd={onAddSession}
            onEdit={onEditSession}
            onDelete={onDeleteSession}
            deleteButtonFirst={true}
            saveNavLink={NavLinks.MEET_SESSIONS}
            backNavLink={NavLinks.MEET_SESSIONS}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  )
}

export default MeetSessionsWrite;